import PropTypes from "prop-types";
import {Link, useLocation, useMatch} from "react-router-dom";

function NavLink({children, className = "", isActive = null, to, ...props}) {
  const location = useLocation();
  const match = useMatch(to, {end: true});
  const active = isActive ? isActive({match, location}) : match;
  const classes = [
    className,
    active && "active"
  ].filter(Boolean).join(" ");

  return <Link className={classes} to={to} {...props}>{children}</Link>;
}

NavLink.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  isActive: PropTypes.func,
  to: PropTypes.string.isRequired
};

export default NavLink;
